import actionTypes from "../actionTypes";
import * as spotrebyUtils from "../../utils/spotreba/spotrebyUtils";

const _DEFAULTS = {
  SORT: [],
  PAGE: { skip: 0, take: 100 },
};

const getSpotrebaRequest = () => ({
  type: actionTypes.GET_SPOTREBA_REQUEST,
});
const getSpotrebaSuccess = (res) => ({
  type: actionTypes.GET_SPOTREBA_SUCCESS,
  res,
});
const getSpotrebaFailure = (error) => ({
  type: actionTypes.GET_SPOTREBA_FAILURE,
  error,
});
export const getSpotreba = ({ NAZOV_OM, customFilters }) => {
  return async (dispatch) => {
    try {
      dispatch(getSpotrebaRequest());

      const { SORT, PAGE } = _DEFAULTS;
      const filter = { filters: [...customFilters] };

      let res = await spotrebyUtils.getSpotreba(NAZOV_OM, filter, SORT, PAGE);
      dispatch(getSpotrebaSuccess(res));
    } catch (error) {
      dispatch(getSpotrebaFailure(error));
    }
  };
};
